import {ChangeEvent, ReactNode} from 'react'
import {Switch} from '@mui/material'
import './CustomSwitch.scss'

const CustomSwitch = ({
                          value,
                          toggleChecked,
                          isChecked = false,
                          disabled = false,
                          dataTestid = '',
                          checkedLabel = 'Always Auto Approve',
                          uncheckedLabel = 'No Auto Approve',
                          name
                      }: {
    value?: string
    toggleChecked: (e: ChangeEvent<HTMLInputElement>) => void
    isChecked?: boolean
    disabled: boolean
    dataTestid?: string,
    checkedLabel?: string | ReactNode
    uncheckedLabel?: string | ReactNode,
    name?: string
}) => {
    const handleToggle = (e: ChangeEvent<HTMLInputElement>) => {
        toggleChecked(e)
    }

    return (
        <label className="custom-switch" data-testid={dataTestid}>
            <Switch name={name} value={value} checked={isChecked} onChange={handleToggle} disabled={disabled}/>
            {isChecked ? <span>{checkedLabel}</span> : <span>{uncheckedLabel}</span>}
        </label>
    )
}
export default CustomSwitch
